module.exports = require("./da-GL.js");